var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6884 14.599C9.33978 15.795 7.16762 17.319 5.78457 18.3647C4.79267 19.1147 4.25 20.2978 4.25 21.5413V42.0888C4.25 43.9024 6.43429 44.954 7.93957 43.9425C10.5097 42.2154 14.001 40.2541 17 39.9184C20.5257 39.5238 23.0128 41.4159 25.5 43.3079C27.9872 45.2 30.4743 47.092 34 46.6974C37.968 46.2532 42.7976 42.9635 45.2154 41.1353C46.2073 40.3853 46.75 39.2023 46.75 37.9588V17.4113C46.75 15.5977 44.5657 14.546 43.0604 15.5576C41.8251 16.3877 40.3769 17.272 38.8729 18.0038C38.2478 20.7175 37.0079 23.552 35.4914 25.9276C34.3657 27.6912 32.983 29.3706 31.3904 30.6424C29.8166 31.8991 27.8042 32.9375 25.5 32.9375C23.1958 32.9375 21.1834 31.8991 19.6096 30.6424C18.017 29.3706 16.6343 27.6912 15.5086 25.9276C13.3365 22.525 11.732 18.1813 11.6884 14.599Z",
    fill: "#9FA6AB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5 29.75C30.8125 29.75 36.125 20.0833 36.125 14.45C36.125 8.8167 31.368 4.25 25.5 4.25C19.632 4.25 14.875 8.8167 14.875 14.45C14.875 20.0833 20.1875 29.75 25.5 29.75ZM25.5 17C27.2604 17 28.6875 15.5729 28.6875 13.8125C28.6875 12.0521 27.2604 10.625 25.5 10.625C23.7396 10.625 22.3125 12.0521 22.3125 13.8125C22.3125 15.5729 23.7396 17 25.5 17Z",
    fill: "#9FA6AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapLocation);
export default __webpack_public_path__ + "static/media/map-location.03f96c6f7e3c59813cda2684faa0b06d.svg";
export { ForwardRef as ReactComponent };